<template>
  <RfSimpleCard class="mb-7 px-7 py-7">
    <div class="flex flex-col">
      <v-expansion-panels v-model="panel" multiple accordion>
        <RfDataSourceEntry
          v-for="dataSource in dataSources"
          :key="dataSource.id"
          :dataSource="dataSource"
          @remove="removeDataSource"
          @uploadCSV="uploadCSV"
          @edit="model => dataSourcesStore.editDataSource({ appId, model })"
        />
      </v-expansion-panels>

      <v-dialog v-model="deleteModal.value" width="500">
        <v-card>
          <v-card-title class="headline">
            Are you sure you want to delete data source '{{ deleteModal.name }}'?
          </v-card-title>
          <v-card-text>
            Deleting this data source removes all information about this data source and all of its
            properties. This cannot be undone.
          </v-card-text>
          <v-card-actions class="modal-card-actions-div">
            <v-btn class="cancel-btn px-7!" variant="outlined" @click="closeDeleteDialog">
              Cancel
            </v-btn>
            <v-btn variant="flat" color="error" class="px-10!" @click="submitDelete">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <RfEditModal ref="newModal" title="Create new data source" @confirm="submitCreate" />
    </div>
  </RfSimpleCard>
</template>

<script>
import RfSimpleCard from "@/components/RfSimpleCard.vue";
import RfEditModal from "@/components/modals/RfEditModal.vue";
import { useDataSourcesStore } from "@/pinia/dataSourcesStore";
import { useUserStore } from "@/pinia/userStore";
import RfDataSourceEntry from "./RfDataSourceEntry.vue";

export default {
  name: "RfDataSourceSettings",
  components: { RfSimpleCard, RfEditModal, RfDataSourceEntry },
  setup: () => ({ dataSourcesStore: useDataSourcesStore(), userStore: useUserStore() }),
  data: () => ({ panel: [0], deleteModal: { value: false, name: "", id: null } }),
  computed: {
    dataSources() {
      return this.dataSourcesStore.dataSources || [];
    },
    appId() {
      return this.$route.params.aid;
    },
  },
  mounted() {
    this.dataSourcesStore.getDataSources(this.appId);
  },
  methods: {
    uploadCSV({ target: { files } }, dataSourceId) {
      const file = files && files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.addEventListener(
        "load",
        ({ target: { result: csv } }) =>
          this.dataSourcesStore.upsertDataSourceCSV({ dataSourceId, csv, appId: this.appId }),
        false,
      );
      reader.readAsDataURL(file);
    },
    submitCreate({ name, description }) {
      const model = { name, description };
      this.dataSourcesStore.createDataSource({ appId: this.appId, model });
    },
    removeDataSource(dataSource) {
      this.deleteModal.value = true;
      this.deleteModal.name = dataSource.name;
      this.deleteModal.id = dataSource.id;
    },
    closeDeleteDialog() {
      this.deleteModal.value = false;
      this.deleteModal.name = "";
      this.deleteModal.id = null;
    },
    submitDelete() {
      this.dataSourcesStore.deleteDataSource({
        appId: this.appId,
        dataSourceId: this.deleteModal.id,
      });
      this.closeDeleteDialog();
    },
    click() {
      this.$refs.newModal.open();
    },
  },
};
</script>
